var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMainMenuProjects = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.04202 5.11229C2.25276 5.46466 2.25211 6.58476 3.04095 6.93806L8.35433 9.31776C9.39317 9.78302 10.581 9.78366 11.6204 9.31951L16.958 6.93586C17.7472 6.58341 17.7477 5.46331 16.9589 5.11009L11.6452 2.73087C10.6066 2.26581 9.41903 2.26517 8.37988 2.72911L3.04202 5.11229Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4999 12L16.932 13.0679C17.7266 13.4168 17.73 14.5428 16.9376 14.8966L11.62 17.2707C10.5809 17.7347 9.39331 17.734 8.35466 17.269L3.05831 14.8975C2.26673 14.5431 2.2708 13.4179 3.06494 13.0692L5.49998 12",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4999 8L16.9485 9.08828C17.7396 9.43988 17.7405 10.5623 16.9501 10.9152L11.62 13.2949C10.5809 13.7588 9.39331 13.7582 8.35466 13.2931L2.92705 10.8629C2.1569 10.518 2.13375 9.43314 2.88849 9.05576L4.99998 8",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMainMenuProjects);
export default ForwardRef;